import {keyMirror} from 'utils/DBUtils';

export const Types = keyMirror({
  SET_CURRENT_LANG: null,
  SET_CURRENT_YEAR: null,
  SET_CURRENT_MONTH: null,

  REQUEST_TOP_REWARDS: null,
  RECEIVED_TOP_REWARDS: null,

  RECEIVED_STORE_ACCOUNT: null,
  SET_STORE_ACCOUNT: null,

  REQUEST_NGC_ENDPOINT_LIST: null,
  RECEIVED_NGC_ENDPOINT_LIST: null,
  RECEIVED_NGC_ENDPOINT_FOR_STORE: null,
  SET_NGC_ENDPOINT: null,

  REQUEST_RETAILERS: null,

  RECEIVED_RETAILERS: null,
  RECEIVED_STORE_ESCROW: null,
  RECEIVED_STORE_ESCROWS: null,

  START_CREATE_STORE_ESCROW: null,
  SUBMIT_CREATE_STORE_ESCROW: null,
  ERROR_CREATING_STORE_ESCROW: null,
  CREATED_STORE_ESCROW: null,
  END_CREATE_STORE_ESCROW: null,

  REQUEST_RETAILER_ITEM_IMAGES: null,
  REQUEST_STORE_CATALOG: null,
  RECEIVED_STORE_CATALOG: null,

  EXPORT_STORE_DATA: null,
  EXPORT_STORE_DATA_SUCCESS: null,
  EXPORT_STORE_DATA_ERROR: null,
  CLOSE_EXPORT_STATUS_MODAL: null,

  START_WRITE_RETAILER_ITEM: null,
  UPDATE_RETAILER_ITEM_IN_PROGRESS: null,
  SUBMIT_CREATE_RETAILER_ITEM: null,
  ERROR_CREATING_RETAILER_ITEM: null,
  SUBMIT_UPDATE_RETAILER_ITEM: null,
  UPDATED_RETAILER_ITEM: null,
  DELETE_RETAILER_ITEM: null,
  END_WRITE_RETAILER_ITEM: null,

  START_VIEW_PURCHASE_INFO: null,
  REQUEST_STORE_ORDERS: null,
  RECEIVED_STORE_ORDERS: null,
  SUBMIT_RESEND_ORDER_EMAIL: null,
  RESENT_ORDER_EMAIL: null,
  CLEAR_RESEND_NOTIFICATION: null,
  END_VIEW_PURCHASE_INFO: null,

  START_INCREASE_ITEM_STOCK: null,
  SUBMIT_INCREASE_ITEM_STOCK: null,
  START_DECREASE_ITEM_STOCK: null,
  SUBMIT_DECREASE_ITEM_STOCK: null,
  UPDATED_ITEM_STOCK: null,
  END_UPDATE_ITEM_STOCK: null,

  SUBMIT_UPDATE_QUANTITY: null,
  QUANTITY_UPDATE_ERROR: null,
  QUANTITY_UPDATE_SUCCESS: null
});

export const setLangAction = lang => ({
  type: Types.SET_CURRENT_LANG,
  lang
});

export const setCurrentYearAction = year => ({
  type: Types.SET_CURRENT_YEAR,
  year
});

export const setCurrentMonthAction = month => ({
  type: Types.SET_CURRENT_MONTH,
  month
});

export const requestTopRewardsAction = lang => ({
  type: Types.REQUEST_TOP_REWARDS,
  lang
});

export const receivedTopRewardsAction = topRewards => ({
  type: Types.RECEIVED_TOP_REWARDS,
  topRewards
});

export const receivedStoreAccountAction = storeAccount => ({
  type: Types.RECEIVED_STORE_ACCOUNT,
  storeAccount
});

export const setStoreAccountAction = storeAccount => ({
  type: Types.SET_STORE_ACCOUNT,
  storeAccount
});


export const requestNgcEndpointListAction = () => ({
  type: Types.REQUEST_NGC_ENDPOINT_LIST

});

export const receivedNgcEndpointListAction = ngcEndpointList => ({
  type: Types.RECEIVED_NGC_ENDPOINT_LIST,
  ngcEndpointList
});

export const receivedNgcEndpointForStoreAction = ngcEndpoint => ({
  type: Types.RECEIVED_NGC_ENDPOINT_FOR_STORE,
  ngcEndpoint
});

export const setNgcEndpointAction = ngcEndpoint => ({
  type: Types.SET_NGC_ENDPOINT,
  ngcEndpoint
});


export const requestRetailersAction = accountId => ({
    type: Types.REQUEST_RETAILERS,
    storeAccount: {
      id: accountId
    }
});

export const receivedRetailersAction = (retailers, storeAccount) => ({
  type: Types.RECEIVED_RETAILERS,
  retailers,
  storeAccount
});

export const receivedStoreEscrowsAction = storeEscrows => ({
  type: Types.RECEIVED_STORE_ESCROWS,
  storeEscrows
});

export const startCreateStoreEscrowAction = month => ({
  type: Types.START_CREATE_STORE_ESCROW,
  month
});

export const receivedStoreEscrowAction = storeEscrow => ({
  type: Types.RECEIVED_STORE_ESCROW,
  storeEscrow
});

export const submitCreateStoreEscrowAction = (lang, year, month, budget, copy) => ({
  type: Types.SUBMIT_CREATE_STORE_ESCROW,
  lang,
  year,
  month,
  budget,
  copy
});

export const errorCreatingStoreEscrowAction = errorCode => ({
  type: Types.ERROR_CREATING_STORE_ESCROW,
  errorCode
});

export const createdStoreEscrowAction = () => ({
  type: Types.CREATED_STORE_ESCROW
});

export const endCreateStoreEscrowAction = () => ({
  type: Types.END_CREATE_STORE_ESCROW
});

export const requestRetailerItemImagesAction = retailerItemId => ({
  type: Types.REQUEST_RETAILER_ITEM_IMAGES,
  retailerItemId
});

export const requestStoreCatalogAction = (lang, escrowId, page) => ({
  type: Types.REQUEST_STORE_CATALOG,
  lang,
  escrowId,
  page
});

export const receivedStoreCatalogAction = storeCatalog => ({
  type: Types.RECEIVED_STORE_CATALOG,
  storeCatalog
});

export const exportStoreDataAction = (lang, escrowId) => ({
  type: Types.EXPORT_STORE_DATA,
  lang,
  escrowId
});

export const exportStoreDataSuccessAction = () => ({
  type: Types.EXPORT_STORE_DATA_SUCCESS
});

export const exportStoreDataErrorAction = () => ({
  type: Types.EXPORT_STORE_DATA_ERROR
});

export const closeExportStatusModalAction = () => ({
  type: Types.CLOSE_EXPORT_STATUS_MODAL
});

export const startWriteRetailerItemAction = (mode, retailerItemResource) => ({
  type: Types.START_WRITE_RETAILER_ITEM,
  mode,
  retailerItemResource // falsy when id is not known, i.e. at creation time
});

export const updateRetailerItemInProgressAction = change => ({
  type: Types.UPDATE_RETAILER_ITEM_IN_PROGRESS,
  change
});

export const submitCreateRetailerItemAction = (lang, formData) => ({
  type: Types.SUBMIT_CREATE_RETAILER_ITEM,
  lang,
  formData
});

export const errorCreatingRetailerItemAction = errorCode => ({
  type: Types.ERROR_CREATING_RETAILER_ITEM,
  errorCode
});

export const submitUpdateRetailerItemAction = (lang, retailerItem) => ({
  type: Types.SUBMIT_UPDATE_RETAILER_ITEM,
  lang,
  retailerItem
});

export const updatedRetailerItemAction = () => ({
  type: Types.UPDATED_RETAILER_ITEM
});

export const endWriteRetailerItemAction = () => ({
  type: Types.END_WRITE_RETAILER_ITEM
});

export const deleteRetailerItemAction = (lang, retailerItem) => ({
  type: Types.DELETE_RETAILER_ITEM,
  lang,
  retailerItem
});

export const startViewPurchaseInfoAction = reward => ({
  type: Types.START_VIEW_PURCHASE_INFO,
  reward
});

export const requestStoreOrdersAction = (retailerItemId, year, month, numPerPage, currentPage) => ({
  type: Types.REQUEST_STORE_ORDERS,
  retailerItemId,
  year,
  month,
  numPerPage,
  currentPage
});

export const receivedStoreOrdersAction = storeOrders => ({
  type: Types.RECEIVED_STORE_ORDERS,
  storeOrders
});

export const submitResendOrderEmailAction = orderId => ({
  type: Types.SUBMIT_RESEND_ORDER_EMAIL,
  orderId
});

export const resentOrderEmailAction = () => ({
  type: Types.RESENT_ORDER_EMAIL
});

export const clearResendNotificationAction = () => ({
  type: Types.CLEAR_RESEND_NOTIFICATION
});

export const endViewPurchaseInfoAction = () => ({
  type: Types.END_VIEW_PURCHASE_INFO
});

export const startIncreaseItemStockAction = retailerItem => ({
  type: Types.START_INCREASE_ITEM_STOCK,
  retailerItem
});

export const submitIncreaseItemStockAction = (lang, escrowId, retailerItemId, totalItems) => ({
  type: Types.SUBMIT_INCREASE_ITEM_STOCK,
  lang,
  escrowId,
  retailerItemId,
  totalItems
});

export const startDecreaseItemStockAction = retailerItem => ({
  type: Types.START_DECREASE_ITEM_STOCK,
  retailerItem
});

export const submitDecreaseItemStockAction = (lang, escrowId, retailerItemId, totalItems) => ({
  type: Types.SUBMIT_DECREASE_ITEM_STOCK,
  lang,
  escrowId,
  retailerItemId,
  totalItems
});

export const updatedItemStockAction = () => ({
  type: Types.UPDATED_ITEM_STOCK
});

export const endUpdateItemStockAction = () => ({
  type: Types.END_UPDATE_ITEM_STOCK
});

export const submitUpdateQuantityAction = (lang, escrowId, retailerItemId, totalItems) => ({
  type: Types.SUBMIT_UPDATE_QUANTITY,
  lang,
  escrowId,
  retailerItemId,
  totalItems
});

export const updateQuantityErrorAction = (retailerItemId, errorCode) => ({
  type: Types.QUANTITY_UPDATE_ERROR,
  retailerItemId,
  errorCode
});

export const updateQuantitySuccessAction = retailerItemId => ({
  type: Types.QUANTITY_UPDATE_SUCCESS,
  retailerItemId
});



// WEBPACK FOOTER //
// ./public/pages/Rewards/actions.js